import { routes } from '@app/app.routes';
import { iconProvider } from '@app/icons';
import { Noir } from '@app/primeng.config';
import { provideHttpCache, withHttpCacheInterceptor } from '@ngneat/cashew';
import * as Sentry from '@sentry/angular';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { Router, provideRouter, withViewTransitions } from '@angular/router';

import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { ENVIRONTMENT_INITIALIZER } from '@cxc/core/environment';
import { environment } from '@environments/environment';

import { MODULES_INITIALIZER } from '@cxc/core/consts';

import { MODULE_PRIORITY } from '@configs/module-priority.const';
import { MODULE_TO_ROUTE } from '@configs/module-to-route.const';
import { MODULES } from '@configs/modules.enum';
import { ROUTE_PATHS } from '@configs/route-paths.const';

import { httpApiKeyInterceptor } from '@interceptors/http-api-key.interceptor';
import { httpAuthorizationInterceptor } from '@interceptors/http-authorization.interceptor';
import { httpErrorInterceptor } from '@interceptors/http-error.interceptor';
import { httpLoaderInterceptor } from '@interceptors/http-loader.interceptor';
import { httpRetryInterceptor } from '@interceptors/http-retry.interceptor';
import { httpTrackEventInterceptor } from '@interceptors/http-track-event.interceptor';

import { CustomToastService } from '@services/custom-toast/custom-toast.service';
import { provideSessionRestore } from '@services/session/provide-session-restore';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ENVIRONTMENT_INITIALIZER,
      useValue: environment,
    },
    {
      provide: MODULES_INITIALIZER,
      useValue: {
        MODULES: MODULES,
        MODULE_PRIORITY: MODULE_PRIORITY,
        ROUTE_PATHS: ROUTE_PATHS,
        MODULE_TO_ROUTE: MODULE_TO_ROUTE,
      },
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    provideSessionRestore(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        // cache is explicit by default, only enabled in specific endpoints
        withHttpCacheInterceptor(),

        httpAuthorizationInterceptor,
        httpApiKeyInterceptor,
        httpLoaderInterceptor,
        httpRetryInterceptor,
        httpErrorInterceptor,
        httpTrackEventInterceptor,
      ])
    ),
    provideHttpCache(),
    providePrimeNG({
      theme: {
        preset: Noir,
        options: {
          darkModeSelector: false,
        },
      },
      translation: {
        dateFormat: 'dd/mm/yy',
      },
    }),
    iconProvider,
    MessageService,
    CustomToastService,
  ],
};
